define((require) => {
    "use strict";

    var LineWidgetModel = require("shared/ui/experience/widgets/lineWidget/LineWidgetModel");

    /**
     * @class {LineWidgetModelEditorMixin}
     *
     * Extra classes used by the editor, but not needed by the viewer.
     */
    return LineWidgetModel.mixin("LineWidgetModelEditorMixin", {
        /**
         * Returns self description string
         *
         * @return {string} The self description
         */
        _getSelfDescription: function() {
            return `Line: ${this.get("lineColor")}`;
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/lineWidget/LineWidgetModelEditorMixin.js